import Amount from "app/pages/.shared/Amount";
import { useSelector, shallowEqual } from "react-redux";

const mapStateToProps = state => {
	return {
		currencyCode: state?.currency,
		shop: state.shop,
	};
};

const AmountContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <Amount {...props} {...stateProps} />;
};

export default AmountContainer;
